import { useState, useEffect } from "react";
import ProfilePic from "../images/dp.png";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useArenaAuth } from "../../context/ArenaAuthContext";
import { useContributorAuth } from "../../context/ContributorAuthContext";
import { useInstituteAuth } from "../../context/InstituteAuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import {
  faBars,
  faSearch,
  faFutbol,
  faUser,
  faClock,
  faMapMarkerAlt,
  faUserCog,
  faSignOutAlt,
  faChalkboardTeacher,
  faUniversity,
  faPenNib,
  faUserTie,
  faStethoscope,
  faAppleAlt,
  faStore,
  faUserFriends,
  faNewspaper,
} from "@fortawesome/free-solid-svg-icons";

const HeaderMain = ({ pageType, onSearch }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userName, setUserName] = useState("");
  const [userProfilePicture, setUserProfilePicture] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [userBalance, setUserBalance] = useState(0);

  const [isFocused, setIsFocused] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showRequestModal, setShowRequestModal] = useState(false);

  const navigate = useNavigate();

  const refreshPage = () => {
    if (
      pageType === "UserAccountSlog" ||
      pageType === "SlogDetails" ||
      pageType === "WriteSlog" ||
      pageType === "UserAccount"
    ) {
      navigate("/Home");
      return;
    }
    if (
      pageType === "Slog" ||
      pageType === "arena-player-req" ||
      pageType === "user-profile" ||
      pageType === "all-news" ||
      pageType === "ArenaUserDashboard" ||
      pageType === "search-article" ||
      pageType === "instituteDashboard"
    ) {
      navigate("/main-dashboard");
      return;
    }
    if (
      pageType === "transaction-history" ||
      pageType === "SelectionOfAddGames" ||
      pageType === "ViewGame" ||
      pageType === "player-profile" ||
      pageType === "user-fitness-stats" ||
      pageType === "user-search-profile"
    ) {
      navigate("/Manage");
      return;
    }
    if (pageType === "AddGame") {
      navigate("/add-game");
      return;
    }
    if (pageType === "viewarticle") {
      navigate("/search");
      return;
    }
    window.location.reload();
    document.documentElement.scrollTop = 0;
  };

  const [userId, setUserId] = useState("");
  const { user, logout } = useAuth();
  const { arenaUser } = useArenaAuth();
  const { contributor } = useContributorAuth();
  const { instituteUser } = useInstituteAuth();

  const fetchUserName = async (userId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/article/get-username/${userId}`
      );
      const { first_name, last_name } = response.data;
      setUserName(`${first_name} ${last_name}`);
    } catch (error) {
      console.error("Error fetching user name:", error);
    }
  };

  const fetchUserProfilePicture = async (userId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/common/get-user-picture/${userId}`
      );

      if (response.data.picture) {
        setUserProfilePicture(
          `data:image/jpeg;base64,${response.data.picture}`
        );
      } else {
        setUserProfilePicture(null); // Will fall back to dummy image
      }
    } catch (error) {
      console.error("Error fetching user profile picture:", error);
      setUserProfilePicture(null); // Will fall back to dummy image
    }
  };

  const fetchNotifications = async (userId) => {
    try {
      // console.log("Fetching notifications for user:", userId);
      // Fetch all notifications to calculate unread count accurately
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/user-invitations?userId=${userId}&limit=50`,
        { withCredentials: true }
      );
      const allNotifications = response.data;
      // console.log("All notifications received:", allNotifications.length);
      // Filter notifications to show only top 5 for dropdown
      const displayNotifications = allNotifications.slice(0, 5);
      setNotifications(displayNotifications);
      // console.log("Display notifications set:", displayNotifications.length);
      // Try to get user's last viewed timestamp, but don't fail if it doesn't exist
      let lastViewedAt = null;
      try {
        const lastViewedResponse = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/get-last-viewed?userId=${userId}&type=sport_requests`,
          { withCredentials: true }
        );
        lastViewedAt = lastViewedResponse.data.last_viewed_at;
        console.log("Last viewed at:", lastViewedAt);
      } catch (error) {
        // console.log("No previous view record found (first time user)");
        // This is fine - first time users won't have a record
      }
      // Count unread notifications (created after last viewed time)
      let unreadCount = 0;
      if (lastViewedAt) {
        const lastViewed = new Date(lastViewedAt);
        unreadCount = allNotifications.filter(
          (notification) => new Date(notification.created_at) > lastViewed
        ).length;
        console.log("Unread count (with last viewed):", unreadCount);
      } else {
        // If never viewed before, all notifications are unread
        unreadCount = allNotifications.length;
        // console.log("Unread count (first time user):", unreadCount);
      }
      // Show "5+" if more than 5 unread, otherwise show exact count
      const finalCount = unreadCount > 5 ? "5+" : unreadCount.toString();
      setUnreadCount(finalCount);
      // console.log("Final unread count displayed:", finalCount);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      // Set empty state on error
      setNotifications([]);
      setUnreadCount("0");
    }
  };

  const fetchUserBalance = async (userId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/accounting/balance/${userId}`
      );
      setUserBalance(response.data.balance);
    } catch (error) {
      console.error("Error fetching user balance:", error);
      setUserBalance(0);
    }
  };

  useEffect(() => {
    if (user?.uid) {
      setIsAuthenticated(true);
      setUserId(user.uid);
      fetchUserName(user.uid);
      fetchNotifications(user.uid);
      fetchUserProfilePicture(user.uid);
      if (pageType === "user-profile") fetchUserBalance(user.uid);
      const notificationInterval = setInterval(() => {
        fetchNotifications(user.uid);
        if (pageType === "user-profile") fetchUserBalance(user.uid);
      }, 100000);
      return () => clearInterval(notificationInterval);
    } else {
      setIsAuthenticated(false);
      setUserId("");
      setUserName("");
      setUserProfilePicture(null);
    }
  }, [user, pageType]);

  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      fetchSuggestions(searchTerm);
    } else {
      setSuggestions([]);
    }
  }, [searchTerm]);

  // Populate search bar with current query from URL when component mounts
  useEffect(() => {
    const currentPath = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    const queryParam = urlParams.get("q");

    if (
      queryParam &&
      (currentPath === "/search-results" ||
        currentPath === "/user-search-results")
    ) {
      setSearchTerm(decodeURIComponent(queryParam));
    }
  }, []);

  const fetchSuggestions = async (term) => {
    if (pageType === "home") {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/article/suggest-articles?term=${term}`
        );
        if (response.ok) {
          const data = await response.json();
          setSuggestions(data);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    } else if (pageType === "user-profile") {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/common/search-users?term=${term}`
        );
        if (response.ok) {
          const data = await response.json();
          setSuggestions(data);
        }
      } catch (error) {
        console.error("Error fetching user suggestions:", error);
      }
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    if (pageType === "Slog") {
      handleSearch(e.target.value);
    }
  };

  const handleSuggestionClick = (item) => {
    if (pageType === "home") {
      navigate(`/article/${item.id}`);
    } else if (pageType === "user-profile") {
      navigate(`/player-profile/${item.id}`);
    }
  };

  const handleSearch = (term) => {
    if (searchTerm.trim()) {
      if (pageType === "home") {
        navigate(`/search-results?q=${encodeURIComponent(searchTerm)}`);
      }
      if (pageType === "Slog") {
        onSearch(searchTerm, slogsActive, peopleActive);
        // handleFilter(slogsActive, peopleActive);
      }
    }
    if (term === "" || term) {
      if (pageType === "home") {
        navigate(`/search-results?q=${encodeURIComponent(term)}`);
      }
      if (pageType === "Slog") {
        onSearch(term, slogsActive, peopleActive);
        // handleFilter(slogsActive, peopleActive);
      }
    }
  };

  // Separate search handler for user-profile pageType only
  const handleUserSearch = (term = null) => {
    const searchValue = term !== null ? term : searchTerm;

    if (searchValue && searchValue.trim && searchValue.trim()) {
      navigate(`/user-search-results?q=${encodeURIComponent(searchValue)}`);
    }
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    if (pageType === "Slog") {
      onSearch("", slogsActive, peopleActive); // Call onSearch with empty string to clear
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (pageType === "user-profile") {
        handleUserSearch(e.target.value);
      } else {
        handleSearch(e.target.value);
      }
    }
  };

  const handleReg = () => navigate("/reg-verification");
  const handleLogIn = () => navigate("/login-Arena");
  const handleManage = () => navigate("/Manage");

  const handleLogOut = async () => {
    await logout();
    setIsAuthenticated(false);
    setUserId("");
    setUserName("");
    setUserProfilePicture(null);
    toast.success("Successfully logged out!");
    navigate("/");
    handleDp();
  };

  const handleDropDown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    if (isDropdownOpen2) setIsDropdownOpen2(false);
    if (isNotificationOpen) setIsNotificationOpen(false);
  };

  const handleDp = () => {
    if (
      pageType === "Slog" ||
      pageType === "SlogDetails" ||
      pageType === "WriteSlog"
    ) {
      navigate("/user-account");
    } else if ("home") {
      setIsDropdownOpen2(!isDropdownOpen2);
      if (isDropdownOpen) setIsDropdownOpen(false);
      if (isNotificationOpen) setIsNotificationOpen(false);
    }
  };

  const handleNotificationToggle = async () => {
    setIsNotificationOpen(!isNotificationOpen);
    if (isDropdownOpen) setIsDropdownOpen(false);
    if (isDropdownOpen2) setIsDropdownOpen2(false);
    // Mark notifications as viewed when dropdown is opened
    if (!isNotificationOpen) {
      try {
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/mark-viewed`,
          {
            userId: userId,
            type: "sport_requests",
          },
          { withCredentials: true }
        );
        setUnreadCount("0");
        console.log("Notifications marked as viewed");
      } catch (error) {
        console.error("Error marking notifications as viewed:", error);
        // Still remove badge on frontend even if API fails
        setUnreadCount("0");
      }
    }
  };
  const handleRequestClick = async (notification) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/invitation-details?invitationId=${notification.id}`,
        { withCredentials: true }
      );
      setSelectedRequest(response.data);
      setShowRequestModal(true);
    } catch (error) {
      console.error("Error fetching request details:", error);
    }
  };
  const handleAcceptReject = async (invitationId, action) => {
    try {
      // Check if we're dealing with grouped notifications (multiple slots)
      const notification = notifications.find((n) => n.id === invitationId);

      if (notification && notification.slots && notification.slots.length > 1) {
        // Use group response for multiple slots
        const invitationIds = notification.slots.map((slot) => slot.id);
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/respond-invitation-group`,
          {
            invitationIds,
            action,
          },
          { withCredentials: true }
        );
      } else {
        // Use single response for single slot
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/respond-invitation`,
          {
            invitationId,
            action,
          },
          { withCredentials: true }
        );
      }

      // Refresh notifications
      fetchNotifications(userId);
      setShowRequestModal(false);
      setSelectedRequest(null);
      toast.success(`Request ${action} successfully!`);
    } catch (error) {
      console.error(`Error ${action} request:`, error);
      toast.error(`Failed to ${action} request. Please try again.`);
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";
    // Handle both time formats
    if (timeString.includes("T")) {
      const date = new Date(timeString);
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } else {
      // Handle HH:MM:SS format
      const [hours, minutes] = timeString.split(":");
      const date = new Date();
      date.setHours(parseInt(hours), parseInt(minutes), 0);
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    }
  };
  const isDatePassed = (date, time) => {
    try {
      // Create proper date object from the booking date and time
      let bookingDate;
      if (date.includes("T")) {
        // If date already contains time
        bookingDate = new Date(date);
      } else {
        // Combine date and time
        if (time && time.includes("T")) {
          const timeOnly = new Date(time).toTimeString().split(" ")[0];
          bookingDate = new Date(`${date}T${timeOnly}`);
        } else {
          bookingDate = new Date(`${date}T${time || "00:00:00"}`);
        }
      }
      const now = new Date();
      return bookingDate < now;
    } catch (error) {
      console.error("Error parsing date:", error);
      return false;
    }
  };
  const getStatusDisplay = (notification) => {
    // For grouped notifications, check if any slot has passed
    if (notification.slots && notification.slots.length > 0) {
      const hasPassedSlots = notification.slots.some(
        (slot) =>
          isDatePassed(notification.date, slot.time) &&
          slot.status === "pending"
      );
      if (hasPassedSlots && notification.status === "pending") {
        return "missed";
      }
    } else {
      // Fallback for single notifications
      if (
        isDatePassed(notification.date, notification.time) &&
        notification.status === "pending"
      ) {
        return "missed";
      }
    }
    return notification.status;
  };
  const handleViewAll = () => {
    navigate("/sport-requests");
  };
  const handleOpenGoogleMaps = (coordinates) => {
    if (coordinates) {
      const [lat, lng] = coordinates.split(",");
      const url = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(url, "_blank");
    }
  };
  const handleContributorLogin = () => {
    navigate("/search");
  };

  const handleAllNews = () => {
    navigate("/all-news");
  };

  const handleArenaLogin = () => {
    if (isAuthenticated === true) {
      navigate("/user-dashboard");
    } else {
      alert("Please log in to access the Arena Dashboard");
    }
  };

  const handleInstitute = () => {
    navigate("/institute-dashboard");
  };

  const handleSlog = () => {
    if (isAuthenticated === true) {
      navigate("/Home");
    } else {
      alert("Please log in to access the Slog Dashboard");
    }
  };

  const handleCoachModule = () => {
    if (isAuthenticated === true) {
      navigate("/coach-user");
    } else {
      alert("Please log in to access the Coach Dashboard");
    }
  };

  const handleRefreeModule = () => {
    if (isAuthenticated === true) {
      navigate("/referee-user");
    } else {
      alert("Please log in to access the Refree Dashboard");
    }
  };

  const handlePhysicianModule = () => {
    if (isAuthenticated === true) {
      navigate("/physician-user");
    } else {
      alert("Please log in to access the Physician Dashboard");
    }
  };

  const handleDietitianModule = () => {
    if (isAuthenticated === true) {
      navigate("/dietitian-user");
    } else {
      alert("Please log in to access the Dietitian Dashboard");
    }
  };

  const handleSportsStoreModule = () => {
    if (isAuthenticated === true) {
      navigate("/ecommerce");
    } else {
      alert("Please log in to access the Dietitian Dashboard");
    }
  };
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const languages = [
    { code: "pk", name: "Urdu", flag: "https://flagcdn.com/w40/pk.png" },
    { code: "en", name: "English", flag: "https://flagcdn.com/w40/us.png" },
    { code: "fr", name: "French", flag: "https://flagcdn.com/w40/fr.png" },
    { code: "es", name: "Spanish", flag: "https://flagcdn.com/w40/es.png" },
    { code: "de", name: "German", flag: "https://flagcdn.com/w40/de.png" },
  ];

  const handleLanguageChange = (code) => {
    setSelectedLanguage(code);
    console.log("Selected language:", code);
  };

  const handleRegArena = () => {
    navigate("/register-arena");
  };

  const handleLogInArena = () => {
    // Check if arena user is already logged in
    if (arenaUser) {
      toast.success("You are already logged in to Arena!");
      navigate("/Arena-dashboard");
      return;
    }
    navigate("/LoginArena");
  };

  const handleLoginClick = () => {
    // Check if contributor is already logged in
    if (contributor) {
      toast.success("You are already logged in as a Contributor!");
      navigate("/contributor-dashboard");
      return;
    }
    navigate("/loginContributor");
  };

  const handleRegisterClick = () => {
    navigate("/register");
  };

  const handleLoginInstitute = () => {
    // Check if institute user is already logged in
    if (instituteUser) {
      toast.success("You are already logged in to Institute!");
      navigate("/institute-owner");
      return;
    }
    navigate("/institute-login");
  };

  const handleRegisterInstitute = () => {
    navigate("/register-institute");
  };

  const [filterOpen, setFilterOpen] = useState(false);
  const [slogsActive, setSlogsActive] = useState(true);
  const [peopleActive, setPeopleActive] = useState(false);

  useEffect(() => {
    // handleFilter(slogsActive, peopleActive);
    handleSearch();
  }, [slogsActive, peopleActive]);

  const words = [
    "Sports Innovation",
    "Athlete Development",
    "Data Analytics",
    "Fan Engagement",
    "Global Connectivity",
    "Sports Business",
  ];

  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      // Fade out
      setVisible(false);

      // After fade-out delay, update word and fade in
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % words.length);
        setVisible(true);
      }, 300); // match fade-out duration
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  const menuItems = [
    { name: "All News", icon: faNewspaper, handler: handleAllNews },
    {
      name: "Soul",
      icon: faChalkboardTeacher,
      handler: handleContributorLogin,
    },
    { name: "Arena", icon: faUniversity, handler: handleArenaLogin },
    { name: "Institute", icon: faUniversity, handler: handleInstitute },
    // { name: "Slog", icon: faPenNib, handler: handleSlog },
    // { name: "Coach", icon: faUserTie, handler: handleCoachModule },
    // { name: "Referee", icon: faUserFriends, handler: handleRefreeModule },
    // { name: "Physician", icon: faStethoscope, handler: handlePhysicianModule },
    // { name: "Dietitian", icon: faAppleAlt, handler: handleDietitianModule },
    // { name: "Sports Store", icon: faStore, handler: handleSportsStoreModule },
  ];

  const dropdownVariants = {
    hidden: { opacity: 0, y: -8, scale: 0.98, originX: 1, originY: 0 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.18, ease: "easeOut" },
    },
    exit: {
      opacity: 0,
      y: -4,
      scale: 0.98,
      transition: { duration: 0.15, ease: "easeIn" },
    },
  };

  return (
    <>
      {/* Top Header with slogan and language dropdown */}

      <header className="flex justify-between items-center px-4 md:px-10 py-2 bg-[#0071bce1]">
        <h6 className="text-white text-[0.5rem] md:text-[0.65rem] leading-none m-0 flex gap-2">
          We are transforming the future of{" "}
          <span
            className={`text-white font-bold transition-opacity duration-300 ${
              visible ? "opacity-100" : "opacity-0"
            }`}
          >
            {words[index]}
          </span>
        </h6>
        <div className="relative group">
          <button className="flex items-center justify-center gap-1 md:gap-1 p-1 md:p-0 border-none bg-transparent cursor-pointer text-white transition-all duration-300 rounded-md hover:shadow-md">
            <div className="flex items-center gap-1">
              <img
                src={
                  languages.find((lang) => lang.code === selectedLanguage)?.flag
                }
                alt="Selected language flag"
                className="w-5 h-3 md:w-7 md:h-5"
              />
              <span className="text-[0.5rem] md:text-sm font-bold">
                {selectedLanguage.toUpperCase()}
              </span>
            </div>
            <span className="ml-2 text-xs text-white">▼</span>
          </button>
          {/* <AnimatePresence>
            <motion.ul
              className="absolute top-full right-0 bg-white border border-gray-300 rounded-md p-0 list-none mt-1 z-20 shadow-md w-fit overflow-hidden opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.15 }}
            >
              {languages.map((lang) => (
                <li
                  key={lang.code}
                  onClick={() => handleLanguageChange(lang.code)}
                  className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100 transition-colors"
                >
                  <img src={lang.flag} alt={lang.name} className="w-5 h-3" />
                  <span className="text-sm">{lang.name}</span>
                  <span className="text-xs text-gray-600">
                    ({lang.code.toUpperCase()})&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </li>
              ))}
            </motion.ul>
          </AnimatePresence> */}
        </div>
      </header>

      {/* Main Header */}
      <div className="sticky top-0 z-10 bg-white">
        <header className="flex justify-between items-center px-4 md:px-10 py-2 md:py-2.5 bg-gray-100 border-b border-gray-300 w-full relative">
          <img
            src="/logo.png"
            alt="Sports Hub Logo"
            onClick={refreshPage}
            className="h-5 md:h-10 cursor-pointer"
          />

          {/* Search Container - Desktop */}
          {(pageType === "Slog" || pageType === "user-profile") && (
            <div className="hidden md:flex relative items-center max-w-[600px] w-full">
              <input
                type="text"
                placeholder={`Search ${
                  pageType === "Slog"
                    ? "Slogs"
                    : pageType === "user-profile"
                    ? "Users"
                    : "Articles"
                }`}
                className="flex-grow p-2.5 text-sm border border-gray-300 rounded-l-md focus:outline-none focus:border-[#0071bc] focus:shadow-sm"
                value={searchTerm}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                onFocus={() => {
                  setIsFocused(true);
                  if (pageType === "Slog") setFilterOpen(true);
                }}
                onBlur={() => {
                  setIsFocused(false);
                  if (searchTerm === "") setFilterOpen(false);
                }}
              />
              {searchTerm && (
                <button
                  onClick={handleClearSearch}
                  className="absolute right-12 text-gray-500 hover:text-gray-700"
                  title="Clear search"
                >
                  ✕
                </button>
              )}
              <div className="bg-[#0071bce1] text-white p-3.5 rounded-r-md cursor-pointer">
                <FontAwesomeIcon
                  icon={faSearch}
                  onClick={() =>
                    pageType === "user-profile"
                      ? handleUserSearch()
                      : handleSearch()
                  }
                />
              </div>

              {/* Suggestions Dropdown */}
              {suggestions.length > 0 && (
                <motion.ul
                  className="absolute top-full left-0 right-0 bg-white border border-gray-300 border-t-0 max-h-72 overflow-y-auto z-50 shadow-lg"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                >
                  {suggestions.map((item) => (
                    <li
                      key={item.id}
                      onClick={() => handleSuggestionClick(item)}
                      className="p-3 cursor-pointer border-b border-gray-200 hover:bg-gray-50 transition-colors"
                    >
                      {pageType === "user-profile" ? (
                        <div className="flex items-center py-2">
                          {item.picture && (
                            <img
                              src={`data:image/jpeg;base64,${item.picture}`}
                              alt="Profile"
                              className="w-8 h-8 rounded-full mr-3 object-cover"
                            />
                          )}
                          <div>
                            <div className="font-bold">{item.display_name}</div>
                            <div className="text-sm text-gray-600">
                              {item.full_name}
                            </div>
                          </div>
                        </div>
                      ) : (
                        item.title
                      )}
                    </li>
                  ))}
                </motion.ul>
              )}
            </div>
          )}

          {/* Right side buttons and profile */}
          <div className="flex items-center gap-2 md:gap-4">
            {/* Arena specific buttons */}
            {pageType === "ArenaUserDashboard" && (
              <>
                <button
                  className="bg-[transparent] text-[#0071bce1] px-2.5 py-1.5  md:px-6.5 md:py-4.5  text-[0.6rem] md:text-[0.7rem]  font-semibold rounded border-1 border-[#0071bce1] transition-transform duration-1000 hover:bg-[#0071bce1] hover:text-white"
                  onClick={handleLogInArena}
                >
                  Login to Arena
                </button>
                <button
                  className="bg-[#0071bce1] hover:bg-[transparent] hover:text-[#0071bce1] text-[#ffffff] text-[0.6rem] md:text-[0.7rem] px-2.5 py-1.5 md:px-6.5 md:py-4.5 font-semibold rounded border-1 border-[#0071bce1] transition-transform duration-1000 "
                  onClick={handleRegArena}
                >
                  Signup
                </button>
              </>
            )}
            {/* Arena specific buttons */}
            {pageType === "search-article" && (
              <>
                <button
                  className="bg-[transparent] text-[#0071bce1] px-2.5 py-1.5  md:px-6.5 md:py-4.5  text-[0.6rem] md:text-[0.7rem]  font-semibold rounded border-1 border-[#0071bce1] transition-transform duration-1000 hover:bg-[#0071bce1] hover:text-white"
                  onClick={handleLoginClick}
                >
                  Login to Soul
                </button>
                <button
                  className="bg-[#0071bce1] hover:bg-[transparent] hover:text-[#0071bce1] text-[#ffffff] text-[0.6rem] md:text-[0.7rem] px-2.5 py-1.5 md:px-6.5 md:py-4.5 font-semibold rounded border-1 border-[#0071bce1] transition-transform duration-1000 "
                  onClick={handleRegisterClick}
                >
                  Signup
                </button>
              </>
            )}

            {pageType === "instituteDashboard" && (
              <>
                <button
                  className="bg-[transparent] text-[#0071bce1] px-2.5 py-1.5  md:px-6.5 md:py-4.5  text-[0.6rem] md:text-[0.7rem]  font-semibold rounded border-1 border-[#0071bce1] transition-transform duration-1000 hover:bg-[#0071bce1] hover:text-white"
                  onClick={handleLoginInstitute}
                >
                  Login to Institute
                </button>
                <button
                  className="bg-[#0071bce1] hover:bg-[transparent] hover:text-[#0071bce1] text-[#ffffff] text-[0.6rem] md:text-[0.7rem] px-2.5 py-1.5 md:px-6.5 md:py-4.5 font-semibold rounded border-1 border-[#0071bce1] transition-transform duration-1000 "
                  onClick={handleRegisterInstitute}
                >
                  Signup
                </button>
              </>
            )}

            {isAuthenticated ? (
              <>
                {/* Balance Display - Only show on user profile page */}
                {pageType === "user-profile" && (
                  <div className="flex items-center gap-1 bg-blue-50 px-2 py-1 rounded-xl border border-[#0071bc] text-xs md:text-sm">
                    <span className="font-semibold text-[#0071bc]">
                      Balance:
                    </span>
                    <span className="font-bold text-[#0071bc]">
                      ${userBalance.toFixed(2)}
                    </span>
                  </div>
                )}

                {/* Sport Requests Icon - Only show on home page */}
                {pageType === "home" && (
                  <div className="relative">
                    <button
                      className="relative p-2 text-[#0071bc] hover:text-[#005a9e] transition-colors"
                      onClick={handleNotificationToggle}
                    >
                      <FontAwesomeIcon icon={faFutbol} className="text-lg" />
                      {unreadCount !== "0" &&
                        unreadCount !== 0 &&
                        unreadCount && (
                          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                            {unreadCount}
                          </span>
                        )}
                    </button>

                    {/* Notification Dropdown */}
                    <AnimatePresence>
                      {isNotificationOpen && (
                        <motion.div
                          className="absolute top-full right-0 bg-white border border-gray-300 rounded-lg shadow-lg w-80 max-w-screen z-50 max-h-96 overflow-y-auto"
                          initial={{ opacity: 0, scale: 0.95, y: -10 }}
                          animate={{ opacity: 1, scale: 1, y: 0 }}
                          exit={{ opacity: 0, scale: 0.95, y: -10 }}
                          transition={{ duration: 0.15 }}
                        >
                          <div className="flex justify-between items-center p-4 border-b border-gray-200">
                            <h4 className="font-bold text-gray-800">
                              Sport Requests
                            </h4>
                            <button
                              onClick={handleViewAll}
                              className="text-[#0071bc] hover:text-[#005a9e] text-sm font-semibold"
                            >
                              View All
                            </button>
                          </div>
                          <div>
                            {notifications.length === 0 ? (
                              <div className="text-center text-gray-600 p-5">
                                No sport requests
                              </div>
                            ) : (
                              notifications.map((notification) => (
                                <div
                                  key={notification.id}
                                  className="p-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer transition-colors"
                                  onClick={() =>
                                    handleRequestClick(notification)
                                  }
                                >
                                  <div className="space-y-1">
                                    <div className="flex items-center text-sm text-gray-700">
                                      <FontAwesomeIcon
                                        icon={faUser}
                                        className="mr-2"
                                      />
                                      <span className="font-semibold">
                                        {notification.inviter_name}
                                      </span>
                                    </div>
                                    <div className="text-sm text-gray-600">
                                      <span>{notification.arena_name}</span>
                                    </div>
                                    <div className="flex items-center text-sm text-gray-600">
                                      <FontAwesomeIcon
                                        icon={faClock}
                                        className="mr-2"
                                      />
                                      <span>
                                        {formatDate(notification.date)}
                                        {notification.slots &&
                                        notification.slots.length > 1
                                          ? ` - ${
                                              notification.slots.length
                                            } slots (${formatTime(
                                              notification.slots[0].time
                                            )} - ${formatTime(
                                              notification.slots[
                                                notification.slots.length - 1
                                              ].time
                                            )})`
                                          : notification.slots &&
                                            notification.slots.length === 1
                                          ? ` at ${formatTime(
                                              notification.slots[0].time
                                            )}`
                                          : notification.time
                                          ? ` at ${formatTime(
                                              notification.time
                                            )}`
                                          : ""}
                                      </span>
                                    </div>
                                    <div
                                      className={`text-xs font-semibold px-2 py-1 rounded ${
                                        getStatusDisplay(notification) ===
                                        "pending"
                                          ? "bg-yellow-100 text-yellow-800"
                                          : getStatusDisplay(notification) ===
                                            "accepted"
                                          ? "bg-green-100 text-green-800"
                                          : getStatusDisplay(notification) ===
                                            "rejected"
                                          ? "bg-red-100 text-red-800"
                                          : getStatusDisplay(notification) ===
                                            "missed"
                                          ? "bg-gray-100 text-gray-800"
                                          : "bg-blue-100 text-blue-800"
                                      }`}
                                    >
                                      {getStatusDisplay(notification)}
                                    </div>
                                  </div>
                                </div>
                              ))
                            )}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                )}

                {/* Profile Picture */}
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={userProfilePicture || ProfilePic}
                    onClick={handleDp}
                    className={`${
                      pageType === "ArenaUserDashboard"
                        ? "w-12 h-12"
                        : "w-12 h-12"
                    } rounded-full object-cover border-2 border-gray-300 cursor-pointer hover:shadow-md transition-shadow`}
                    alt="Profile"
                  />
                </div>
              </>
            ) : (
              <>
                {window.location.pathname === "/" && (
                  <div className="relative right-4 gap-2 flex items-center">
                    <button
                      onClick={handleLogIn}
                      className="bg-[transparent] text-[#0071bce1] px-2.5 py-1.5  md:px-6.5 md:py-4.5  text-[0.6rem] md:text-[0.7rem]  font-semibold rounded border-1 border-[#0071bce1] transition-transform duration-1000 hover:bg-[#0071bce1] hover:text-white"
                    >
                      Login to Hub
                    </button>
                    <button
                      onClick={handleReg}
                      className="bg-[#0071bce1] hover:bg-[transparent] hover:text-[#0071bce1] text-[#ffffff] text-[0.6rem] md:text-[0.7rem] px-2.5 py-1.5 md:px-6.5 md:py-4.5 font-semibold rounded border-1 border-[#0071bce1] transition-transform duration-1000 "
                    >
                      SignUp
                    </button>
                  </div>
                )}
              </>
            )}

            <div className="relative flex items-center gap-6">
              {/* Main Menu Button */}
              <button
                className="text-[#0071bc] hover:text-[#005a9e] transition-colors p-2 rounded-md hover:bg-gray-200"
                onClick={handleDropDown}
              >
                <FontAwesomeIcon icon={faBars} className="text-lg" />
              </button>

              {/* Main Menu Dropdown */}
              <AnimatePresence>
                {isDropdownOpen && (
                  <motion.div
                    className="absolute right-0 bg-white shadow-xl z-30 border border-gray-200 rounded-lg overflow-hidden w-64"
                    style={{ top: "100%" }}
                    variants={dropdownVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                  >
                    {menuItems.map((item, index) => (
                      <a
                        key={index}
                        onClick={item.handler}
                        className="flex items-center gap-3 py-3 px-4 text-sm font-medium text-gray-700 cursor-pointer transition-all duration-200 hover:bg-gray-200 hover:text-gray-900 text-decoration-none"
                      >
                        <FontAwesomeIcon icon={item.icon} className="w-4" />
                        {item.name}
                      </a>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>

              {/* User Profile Dropdown */}
              <AnimatePresence>
                {isDropdownOpen2 && (
                  <motion.div
                    className="absolute top-full right-0 bg-white shadow-xl z-40 rounded-lg overflow-hidden w-56"
                    variants={dropdownVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                  >
                    {/* Profile Section */}
                    <div className="flex flex-col items-center py-4 border-b border-gray-200">
                      <img
                        src={userProfilePicture || ProfilePic}
                        alt="Profile"
                        onClick={handleDp}
                        className="w-12 h-12 rounded-full object-cover border-2 border-gray-300 cursor-pointer hover:scale-105 transition-transform duration-200"
                      />
                      <h3 className="font-semibold text-base mt-2 text-gray-900">
                        {userName}
                      </h3>
                    </div>

                    {/* Actions */}
                    <div className="flex flex-col p-2 gap-2">
                      <button
                        onClick={handleManage}
                        className="flex items-center justify-center gap-2 bg-white text-[#0071bce1] border border-[#0071bce1] px-3 py-2 rounded text-xs font-bold hover:bg-gradient-to-r hover:from-[#0071bce1] hover:to-[#0071bce1] hover:text-white transition-all"
                      >
                        <FontAwesomeIcon icon={faUserCog} />
                        Manage Account
                      </button>
                      <button
                        onClick={handleLogOut}
                        className="flex items-center justify-center gap-2 bg-[#0071bce1] text-white px-3 py-2 rounded text-xs font-bold border transition-all"
                      >
                        <FontAwesomeIcon icon={faSignOutAlt} />
                        Logout
                      </button>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </header>

        {/* Mobile Search Container */}
        <div className="block md:hidden px-3 py-2">
          {(pageType === "Slog" || pageType === "user-profile") && (
            <div className="flex relative items-center w-full">
              <input
                type="text"
                placeholder={`Search ${
                  pageType === "Slog"
                    ? "Slogs"
                    : pageType === "user-profile"
                    ? "Users"
                    : "Articles"
                }`}
                className="flex-grow p-1.5 text-xs h-7 border border-gray-300 rounded-l-md focus:outline-none focus:border-[#0071bc]"
                value={searchTerm}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                onFocus={() => {
                  setIsFocused(true);
                  if (pageType === "Slog") setFilterOpen(true);
                }}
                onBlur={() => {
                  setIsFocused(false);
                  if (searchTerm === "") {
                    setFilterOpen(false);
                  }
                }}
              />
              {searchTerm && (
                <button
                  onClick={handleClearSearch}
                  className="absolute right-8 text-gray-500 hover:text-gray-700 text-sm"
                  title="Clear search"
                >
                  ✕
                </button>
              )}
              <div className="bg-[#0071bce1] text-white p-1.5 rounded-r-md cursor-pointer">
                <FontAwesomeIcon
                  icon={faSearch}
                  className="text-sm"
                  onClick={() =>
                    pageType === "user-profile"
                      ? handleUserSearch()
                      : handleSearch()
                  }
                />
              </div>

              {/* Mobile Suggestions */}
              {suggestions.length > 0 && (
                <motion.ul
                  className="absolute top-full left-0 right-0 bg-white border border-gray-300 border-t-0 max-h-72 overflow-y-auto z-50 shadow-lg"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                >
                  {suggestions.map((item) => (
                    <li
                      key={item.id}
                      onClick={() => handleSuggestionClick(item)}
                      className="p-3 cursor-pointer border-b border-gray-200 hover:bg-gray-50 transition-colors"
                    >
                      {pageType === "user-profile" ? (
                        <div className="flex items-center py-2">
                          {item.picture && (
                            <img
                              src={`data:image/jpeg;base64,${item.picture}`}
                              alt="Profile"
                              className="w-8 h-8 rounded-full mr-3 object-cover"
                            />
                          )}
                          <div>
                            <div className="font-bold">{item.display_name}</div>
                            <div className="text-sm text-gray-600">
                              {item.full_name}
                            </div>
                          </div>
                        </div>
                      ) : (
                        item.title
                      )}
                    </li>
                  ))}
                </motion.ul>
              )}
            </div>
          )}
        </div>

        {/* Filter Buttons */}
        {filterOpen && (
          <motion.div
            className="flex justify-center gap-8 py-2 bg-gray-100 shadow-md"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            <button
              className={`px-4 py-1 rounded-full text-sm font-bold border transition-colors ${
                slogsActive
                  ? "bg-[#0071bc] text-white border-[#0071bc]"
                  : "bg-transparent text-gray-600 border-gray-400 hover:bg-gray-200"
              }`}
              onClick={() => {
                setSlogsActive((prev) => !prev);
              }}
            >
              Slogs
            </button>

            <button
              className={`px-4 py-1 rounded-full text-sm font-bold border transition-colors ${
                peopleActive
                  ? "bg-[#0071bc] text-white border-[#0071bc]"
                  : "bg-transparent text-gray-600 border-gray-400 hover:bg-gray-200"
              }`}
              onClick={() => {
                setPeopleActive((prev) => !prev);
              }}
            >
              People
            </button>
          </motion.div>
        )}
      </div>

      {/* Request Details Modal */}
      <AnimatePresence>
        {showRequestModal && selectedRequest && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999] p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <motion.div
              className="bg-white rounded-lg max-w-lg w-full max-h-[90vh] overflow-y-auto shadow-2xl"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <div className="flex justify-between items-center p-4 border-b border-gray-200">
                <h3 className="text-lg font-bold">Sport Request Details</h3>
                <button
                  className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
                  onClick={() => {
                    setShowRequestModal(false);
                    setSelectedRequest(null);
                  }}
                >
                  ×
                </button>
              </div>
              <div className="p-4 space-y-4">
                {/* Inviter Details */}
                <div>
                  <h4 className="font-bold text-gray-800 flex items-center mb-2">
                    <FontAwesomeIcon icon={faUser} className="mr-2" /> Player
                    Details
                  </h4>
                  <div className="grid grid-cols-1 gap-2 text-sm">
                    <div>
                      <strong>Name:</strong> {selectedRequest.inviter_name}
                    </div>
                    <div>
                      <strong>Email:</strong> {selectedRequest.inviter_email}
                    </div>
                    <div>
                      <strong>Contact:</strong>{" "}
                      {selectedRequest.inviter_contact || "N/A"}
                    </div>
                  </div>
                </div>

                {/* Arena Details */}
                <div>
                  <h4 className="font-bold text-gray-800 flex items-center mb-2">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2" />{" "}
                    Arena Details
                  </h4>
                  <div className="grid grid-cols-1 gap-2 text-sm">
                    <div>
                      <strong>Arena:</strong> {selectedRequest.arena_name}
                    </div>
                    <div>
                      <strong>Phone:</strong> {selectedRequest.arena_telephone}
                    </div>
                    <div>
                      <strong>Facility:</strong>{" "}
                      {selectedRequest.about_facility}
                    </div>
                    <div>
                      <strong>Date:</strong> {formatDate(selectedRequest.date)}
                    </div>
                    {selectedRequest.slots &&
                    selectedRequest.slots.length > 1 ? (
                      <div>
                        <strong>Time Slots:</strong>
                        <div className="flex flex-wrap gap-1 mt-1">
                          {selectedRequest.slots.map((slot, index) => (
                            <span
                              key={slot.id}
                              className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs"
                            >
                              {formatTime(slot.time)}
                              {index < selectedRequest.slots.length - 1 && ", "}
                            </span>
                          ))}
                        </div>
                      </div>
                    ) : selectedRequest.slots &&
                      selectedRequest.slots.length === 1 ? (
                      <div>
                        <strong>Time:</strong>{" "}
                        {formatTime(selectedRequest.slots[0].time)}
                      </div>
                    ) : selectedRequest.time ? (
                      <div>
                        <strong>Time:</strong>{" "}
                        {formatTime(selectedRequest.time)}
                      </div>
                    ) : null}
                    <div>
                      <strong>Address:</strong> {selectedRequest.arena_address}
                    </div>
                    {selectedRequest.coordinates && (
                      <div>
                        <strong>Location:</strong>
                        <button
                          className="ml-2 bg-blue-500 text-white px-2 py-1 rounded text-xs hover:bg-blue-600 transition-colors"
                          onClick={() =>
                            handleOpenGoogleMaps(selectedRequest.coordinates)
                          }
                        >
                          View on Google Maps
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {/* Message */}
                {selectedRequest.message && (
                  <div>
                    <h4 className="font-bold text-gray-800 mb-2">Message</h4>
                    <p className="text-sm bg-gray-50 p-3 rounded">
                      {selectedRequest.message}
                    </p>
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div className="p-4 border-t border-gray-200 flex justify-end gap-2">
                {(() => {
                  // Check if all slots have passed for grouped requests
                  const allSlotsPassed =
                    selectedRequest.slots && selectedRequest.slots.length > 0
                      ? selectedRequest.slots.every((slot) =>
                          isDatePassed(selectedRequest.date, slot.time)
                        )
                      : isDatePassed(
                          selectedRequest.date,
                          selectedRequest.time
                        );

                  if (allSlotsPassed && selectedRequest.status === "pending") {
                    return (
                      <div className="text-gray-500 font-semibold">
                        This request has expired
                      </div>
                    );
                  } else if (selectedRequest.status === "pending") {
                    return (
                      <>
                        className="bg-[transparent] text-[#0071bce1] px-2 py-1
                        md:px-6 md:py-4 text-[0.6rem] md:text-[0.8rem]
                        font-semibold rounded border-1 border-[#0071bce1]
                        transition-transform duration-1000 hover:bg-[#0071bce1]
                        hover:text-white"
                        <button
                          className="bg-[transparent] text-[#0071bce1] px-4 py-2 rounded transition-transform duration-1000 hover:bg-[#0071bce1] hover:text-white border-[#0071bce1]"
                          onClick={() =>
                            handleAcceptReject(
                              selectedRequest.invitation_id ||
                                selectedRequest.id,
                              "accepted"
                            )
                          }
                        >
                          Accept{" "}
                          {selectedRequest.slots &&
                          selectedRequest.slots.length > 1
                            ? `All ${selectedRequest.slots.length} Slots`
                            : ""}
                        </button>
                        <button
                          className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition-colors"
                          onClick={() =>
                            handleAcceptReject(
                              selectedRequest.invitation_id ||
                                selectedRequest.id,
                              "rejected"
                            )
                          }
                        >
                          Reject{" "}
                          {selectedRequest.slots &&
                          selectedRequest.slots.length > 1
                            ? `All ${selectedRequest.slots.length} Slots`
                            : ""}
                        </button>
                      </>
                    );
                  } else {
                    return (
                      <div
                        className={`px-4 py-2 rounded font-semibold ${
                          selectedRequest.status === "accepted"
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800"
                        }`}
                      >
                        {selectedRequest.status.charAt(0).toUpperCase() +
                          selectedRequest.status.slice(1)}
                      </div>
                    );
                  }
                })()}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default HeaderMain;
